import { render } from "./KskChip.vue?vue&type=template&id=2996fbd5&scoped=true"
import script from "./KskChip.vue?vue&type=script&lang=js"
export * from "./KskChip.vue?vue&type=script&lang=js"

import "./KskChip.vue?vue&type=style&index=0&id=2996fbd5&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2996fbd5"]])

export default __exports__